import React from "react";
import SectionTitle from "../components/SectionTitle";
import ContactForm from "../components/ContactForm";
import { useLang } from "../context/LangContext";
import { Link } from "react-router-dom";
import { pathFor } from "../lib/routes";
import { Lock } from "lucide-react";

export default function Investors() {
  const { lang } = useLang();
  const p = (k) => pathFor(k, lang);
  return (
    <main className="pt-32" data-testid="page-investors">
      <section className="container-luxe py-16">
        <SectionTitle
          eyebrow="INVESTORS"
          title={lang === "fr" ? "Un actif premium sur un marché captif." : "A premium asset in a captive market."}
          subtitle={lang === "fr" ? "Riviera Shockwaves opère un service récurrent sur l'un des marchés les plus liquides au monde : yachting, événementiel, HNWI, GP." : "Riviera Shockwaves operates a recurring service in one of the most liquid markets in the world: yachting, events, HNWI, GP."}
        />
      </section>
      <section className="container-luxe pb-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px hairline">
          {[{k:"TAM Riviera",v:"€2.4B"},{k:"Marge brute",v:"68%"},{k:"Rétention",v:"82%"}].map((m)=>(
            <div key={m.k} className="bg-surface-1 p-8">
              <div className="overline">{m.k}</div>
              <div className="font-display text-3xl text-[var(--ink)] mt-2 font-light">{m.v}</div>
            </div>
          ))}
        </div>
      </section>
      <section className="container-luxe pb-12">
        <Link to={p("investorMode")} className="beam-card flex items-center justify-between p-7" data-testid="investor-mode-link">
          <div>
            <div className="overline mb-2">INVESTOR MODE · PRIVATE</div>
            <div className="font-display text-xl text-[var(--ink)]">ROI Simulator · Market opportunity · Monaco GP model</div>
          </div>
          <Lock size={20} className="text-[var(--gold)]" />
        </Link>
      </section>
      <section className="container-luxe pb-24"><ContactForm source="investor" /></section>
    </main>
  );
}
